export default __webpack_public_path__ + "static/media/footer-bg.b998cbca.png";